module.exports = __webpack_public_path__ + "static/media/bed-and-breakfast.18b5fe2e.jpg";